import { render, staticRenderFns } from "./Doctorreviewlist.vue?vue&type=template&id=0ab0df77&scoped=true&"
import script from "./Doctorreviewlist.vue?vue&type=script&lang=js&"
export * from "./Doctorreviewlist.vue?vue&type=script&lang=js&"
import style0 from "./Doctorreviewlist.vue?vue&type=style&index=0&id=0ab0df77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0df77",
  null
  
)

export default component.exports